import {Decimal} from 'decimal.js';

/* This function is used in order to merge the data of the server with the data
of the country. If it finds 2 identical id, it will combine the keys together in one key*/
export const mergeById = (a1, a2) =>
    a1.map(itm => ({
        ...a2.find((item) => (item.id === itm.id) && item),
        ...itm
    }));

/** This function is used to remove the duplicates into an array which are
 * specified in the parameter "elem". At the end we will get a new array with 
 * unique values.
 */
export const removeDuplicate = (array, elem) => {
    return array.reduce((unique, item) => { 
        return unique.includes(item[elem]) ? unique : [...unique, item[elem]]
        },[]);
}

// This function counts the occurrences of an array of objects.
export const getOccurrencesCounter = (categories) => {
    return categories.reduce(function(obj, b) {
        obj[b] = ++obj[b] || 1;
        return obj;
    }, {});
}

// This order an array of objects in an ascendent mode.
export const sortObj = (obj) => {
    return Object.keys(obj).sort().reduce(function (result, key) {
      result[key] = obj[key];
      return result;
    }, {});
  }

//This function is used to capitalize. It converts every first letter of all the words of a string in Uppercase.
export const capitalizeAllFirstLetter = (str) =>  {
    return str.replace(/(^|\s)\S/g, letter => letter.toUpperCase())
}
// this function is to search
export const findCountryByEventId = (events, id) => {
    const item = events.find(element => element.eventId === id);
    
    if(undefined === item) {
       // console.log(item)
        return '';
    }

    return item.id;
}

/** this function is used to find the EndLong and EndLat Coordinates. And it returns
 the END POINT of a couple of markers.
*/ 
export const findEndMarkerCoordinates = (markers, startMarkerCoordinates) => {
    //let endCoordinate = [];
    const endCoordinate = markers.filter(coordinate => {
       return  coordinate.latStart.equals(startMarkerCoordinates.latitude) && 
         coordinate.lngStart.equals(startMarkerCoordinates.longitude)
        }
    ).map(item => {
        return {latitude: item.latEnd, longitude: item.lngEnd }
    });

    return endCoordinate;
}
